export enum APP_PAGES {
  SEARCH = "/search",
  CUSTOMER_DETAILS = "/:name",
  RESOURCES = "/resources",
}
